export class QueryModel {
  currentPage: number = 1;
  pageSize: number = 10;
  sort: string = 'Id';
  sortDirection: string = 'des';
  searchTerm: string = '';
}

export interface IFilter {
  searchTerm: string
}
